import { PHONE_GROUP_AT } from '../constants/code';

export const groupPhoneDigits = (digits: string): string =>
  digits.length > PHONE_GROUP_AT ? `${digits.slice(0, PHONE_GROUP_AT)} ${digits.slice(PHONE_GROUP_AT)}` : digits;
